import moment from 'moment';
import React, { useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import useApi from '../../hooks/useApi';
import { apiUrls } from '../../utils/api/apiUrls';
import { downloadReportsFun } from '../../../srcWeb/utils/helpers';
import { toast } from 'react-toastify';
import FileInput from '../../../srcWeb/components/FileInput/FileInput';

const UploadReports = () => {
    const [searchParams] = useSearchParams();
    const [fileD, setFileD] = useState([])
    const [startDate, setStartDate] = useState(
      moment(
        searchParams.get("startDate") || moment().subtract({ days: 7 }).toDate()
      ).toDate()
    );
    const [endDate, setEndDate] = useState(
      moment(searchParams.get("endDate") || new Date()).toDate()
    );
    const {data: fileData,  apiCall: fileDownload } = useApi();
    const { apiCall: uploadVoucherFile } = useApi();
  
  
    const onClickDownloadFile = () => {
      const st =`${moment(startDate).format('YYYY-MM-DD')} 00:00:00`;
      const et = `${moment(endDate).format('YYYY-MM-DD')} 23:59:59`;
      fileDownload({
        url: `${apiUrls.dmsService.getDownloadVoucherReport}?endDate=${et}&startDate=${st}`,
        method: "get",
        responseType: "blob",
        responseData: (res) => {
          const { data = "", status = null } = res || {};
          const contentType = res?.headers?.["content-type"];
          const contentDisposition = res?.headers["content-disposition"];
          const fileNameMatch =
            contentDisposition && contentDisposition.match(/filename="(.+)"/);
          const fileName = fileNameMatch
            ? fileNameMatch[1]
            : "downloaded-file.xlsx";
          if(status === 200) {
            toast.success("Download File Successfully");
            downloadReportsFun(data, fileName, contentType);
          } else {
            toast.success("Something Went Wrong");
          }
        },
      });
    };
  
    const submitFile = () => {
      const formData = new FormData();
      formData.append("files", fileD[0]);
      console.log("set file data", fileD[0] ,formData);
      uploadVoucherFile({
        url: apiUrls.dmsService.uploadVoucherFileReport,
        method: "post",
        dataToSend: formData,
        onSuccess: (res) => {
          toast.success("File submitted successfully");
          console.log("submit file", res);
        },
        onFail: (err) => {
          const { message = "Something went wrong" } = err?.data || {}
          toast.warning(message)
        }
      })
    }
    
    const onChangeDate = (dates) => {
      const [start, end] = dates;
      setStartDate(start);
      setEndDate(end);
      // if (end) savedVouchersApiCall(start, end);
    };
  
    return (
      <div className="flex justify-between py-2">
        {/* <div className="flex justify-end mt-3 mb-8">
          <div className="flex items-center gap-x-3">
            <div className="font-size-medium">Date Range</div>
  
            <DatePicker
              startDate={startDate}
              endDate={endDate}
              onChange={onChangeDate}
              maxDate={new Date()}
              dateRange
            />
          </div>
        </div> */}
        <div className="flex flex-col grow ml-8">
          {/* <div onClick={onClickDownloadFile} className="border rounded-md px-2 py-1 flex justify-evenly cursor-pointer" style={{ width: '46.5%'}}>
            <span className="font-size-large mr-3">Download Report</span>
            <img src={icons.downloadIcon} />
          </div> */}
          <div className="mt-3 flex">
            <span className="">
              {/* Upload Report */}
              <FileInput
                mainClass={""}
                onChangeInput={(val) => {
                  const filesArray = Array.from(val);
                  console.log("adfasdf", filesArray);
  
                  setFileD(filesArray)
                  // setFieldValue("files", filesArray);
                }}
                inputClass={"w-6/12"}
                isMultiple={false}
                value={null}
              />
            </span>
            <span onClick={submitFile} className="font-size-medium border bg-black text-white rounded-lg px-3 py-1 ml-2 cursor-pointer" style={{ height: '36px'}}>Submit</span>
          </div>
        </div>
        {/* <div className="flex items-center self-end mt-5 gap-x-6">
  
          <CustomButton
            title="Download"
          //   wrapperClassName={`!px-10 ${
          //     selectedCheckBoxes?.length > 0 ? "" : "disabled-kv"
          //   }`}
            onClick={() => {
              let reportSettings = {
                fileName: "Saved Vouchers", // Name of the resulting spreadsheet
                extraLength: 3, // A bigger number means that columns will be wider
                writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
                writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
                RTL: false, // Display the columns from right-to-left (the default value is false)
              };
  
              if (data?.[0]?.documents?.length > 0) {
                downloadReports(
                  [
                    {
                      sheet: "Saved Vouchers",
                      columns: [
                        {
                          label: "Date",
                          value: (row) => row.date,
                        }, // Top level data
                        {
                          label: "Head",
                          value: (row) => row.head,
                        }, // Top level data
                        { label: "Amount", value: (row) => row.amount }, // Top level data
                        {
                          label: "Comment",
                          value: (row) => row?.comment || "-",
                        }, // Top level data
                      ],
                      // content: selectedCheckBoxes?.map((item) => item?.original),
                    },
                  ],
                  reportSettings
                );
              }
            }}
          />
        </div> */}
      </div>
    );
  };
  

export default UploadReports